// @flow
import type { StrictStringMap } from '@rover/react-lib/types';

import I18N_FORMAT_MAP from '@rover/design-system/style-dictionary/build/es6/i18nFormatMap.constants';
import generateExternalFormatMap from './generateExternalFormatMap';
import generateFormatMap from './generateFormatMap';
import getLocalizedFormatInjected from './getLocalizedFormatInjected';

const EXTERNAL_FORMAT_MAP: StrictStringMap = generateExternalFormatMap(getLocalizedFormatInjected);

const FORMAT_KEYS: StrictStringMap = generateFormatMap(getLocalizedFormatInjected);

export {
  FORMAT_KEYS as default,
  getLocalizedFormatInjected as mf,
  EXTERNAL_FORMAT_MAP,
  I18N_FORMAT_MAP,
};



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/datetimeInjected.js